/**
 * @generated SignedSource<<e0aedd5a0fba388144db4f83fa45452c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountAddressFragment$data = {
  readonly addressLineOne: string | null;
  readonly addressLineTwo: string | null;
  readonly city: string | null;
  readonly state: string | null;
  readonly countryId: string | null;
  readonly zip: string | null;
  readonly " $fragmentType": "accountAddressFragment";
};
export type accountAddressFragment$key = {
  readonly " $data"?: accountAddressFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountAddressFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountAddressFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addressLineOne",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addressLineTwo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zip",
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "57246cb5c60f2501e6152766cfcb6925";

export default node;
